import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import BaseConfirmationDialog from '../../components/dialog/BaseConfirmationDialog';
import StudentChatDialog from '../../components/studentsChatsDialog/StudentChatDialog';
import LessonInfoDialogContainer from '../common/lessonInfoDialog/LessonInfoDialogContainer';
import LessonFilePreviewDialog from '../common/lessonInfoDialog/LessonFilePreviewDialog';
import UploadTrackDialogContainer from '../common/uploadTrack/UploadTrackDialogContainer';
import {DialogTypes, PlatformMode} from '../../constants/enums';
import ChangeUserAvatarContainer from '../main/changeUserAvatarDialog';
import ExerciseDialogContainer from '../create/exercise/ExerciseDialogContainer';
import InviteStudentDialog from '../main/select-student/InviteStudentDialog';
import StudentAddConfirmDialog from '../main/select-student/StudentAddConfirmDialog';
import RenameProjectDialog from '../main/setProjectNameDialog/RenameProjectDialog';
import SetProjectNameDialog from '../main/setProjectNameDialog/SetProjectNameDialog';
import DiscoverVideoDialog from '../main/discover/DiscoverVideoDialog';
import {isAdmin, isTeacher} from '../../utils/userUtility';
import SchoolDialog from '../main/schools/SchoolDialog';
import AddGroupDialog from '../main/groups/AddGroupDialog';
import PromoDialog from '../common/promoDialog/PromoDialog';
import StudentMeetingDialog from '../../components/studentsMeetingDialog/StudentMeetingDialog';
import TeacherStartMeetingDialog from '../../components/teacherStartMeetingDialog/TeacherStartMeetingDialog';
import {isDesktop} from '../../utils/screenUtility';
import ResendLoginDialog from '../main/students/manage/ResendLoginDialog';
import SetFolderNameDialog from '../main/folders/SetFolderNameDialog';

@inject('dialogStore', 'projectStore', 'mainStore')
@observer
class AppDialogsContainer extends Component {
    componentDidMount() {
        // this.props.dialogStore.startPromoDialogTimeout();
    }

    render() {
        const {dialogStore, projectStore, mainStore} = this.props;
        const {
            closeFilePreviewDialog, showFilePreviewDialog,
            showRecordingDisable, closeRecordingDisable,
            getDialogState, closeDialog
        } = dialogStore;
        const {platformMode} = mainStore;
        const duplicateConfirmation = {
            question: 'library.lessons.duplicateSuccess.title',
            message: 'library.lessons.duplicateSuccess.message'
        };
        const recordingDisable = {
            question: 'upload.recorder.disableIpadChrome.header',
            message: 'upload.recorder.disableIpadChrome.message'
        };
        const cloneConfirmation = {
            question: 'home.pages.lessonPlan.cloneSuccess.title',
            message: 'home.pages.lessonPlan.cloneSuccess.message'
        };
        return (
            <div>
                <LessonInfoDialogContainer/>
                {platformMode === PlatformMode.Home && showFilePreviewDialog && <LessonFilePreviewDialog
                    open={showFilePreviewDialog}
                    onClose={closeFilePreviewDialog}
                    file={projectStore.openedFile}
                    video={projectStore.openedVideo}
                />}
                <ChangeUserAvatarContainer/>
                <UploadTrackDialogContainer/>
                <SetProjectNameDialog/>
                <RenameProjectDialog/>
                <SetFolderNameDialog/>
                <ExerciseDialogContainer/>
                <BaseConfirmationDialog
                    className="unassign-lesson"
                    onDismiss={() => closeDialog(DialogTypes.DuplicateProjectSuccess)}
                    onSubmit={() => closeDialog(DialogTypes.DuplicateProjectSuccess)}
                    open={getDialogState(DialogTypes.DuplicateProjectSuccess)}
                    onOutsideClick={() => closeDialog(DialogTypes.DuplicateProjectSuccess)}
                    text={duplicateConfirmation}
                    isCancel={false}
                />
                <BaseConfirmationDialog
                    className="unassign-lesson"
                    onDismiss={() => closeDialog(DialogTypes.CloneProjectSuccess)}
                    onSubmit={() => closeDialog(DialogTypes.CloneProjectSuccess)}
                    open={getDialogState(DialogTypes.CloneProjectSuccess)}
                    onOutsideClick={() => closeDialog(DialogTypes.CloneProjectSuccess)}
                    text={cloneConfirmation}
                    isCancel={false}
                />
                <BaseConfirmationDialog
                    className="recording-disable"
                    onDismiss={closeRecordingDisable}
                    onSubmit={closeRecordingDisable}
                    open={showRecordingDisable}
                    onOutsideClick={closeRecordingDisable}
                    text={recordingDisable}
                    buttonText={'close'}
                />
                <InviteStudentDialog/>
                <StudentAddConfirmDialog/>
                <BaseConfirmationDialog
                    open={dialogStore.showUserIsAlreadyRegisteredDialog}
                    onSubmit={dialogStore.closeUserIsAlreadyRegisteredDialog}
                    onDismiss={dialogStore.closeUserIsAlreadyRegisteredDialog}
                    onOutsideClick={dialogStore.closeUserIsAlreadyRegisteredDialog}
                    buttonText='gotIt'
                    text={{question: 'manage.invite.exists.title', message: 'manage.invite.exists.message'}}
                    isCancel={false}
                />
                <BaseConfirmationDialog
                    className="no-students-dialog"
                    open={dialogStore.showNoStudentsDialog}
                    onSubmit={dialogStore.submitNoStudentsDialog}
                    onDismiss={dialogStore.closeNoStudentsDialog}
                    onOutsideClick={dialogStore.closeNoStudentsDialog}
                    buttonText='addStudents'
                    text={{question: 'manage.noStudents.title', message: 'manage.noStudents.message'}}
                    isCancel={false}
                />
                {isTeacher() && <DiscoverVideoDialog/>}
                {isTeacher() && <AddGroupDialog/>}
                {isAdmin() && <SchoolDialog/>}
                <PromoDialog type={dialogStore.promoTestType}/>
                <StudentMeetingDialog open={dialogStore.getDialogState(DialogTypes.StudentZoomMeeting)}
                                      onClose={() => closeDialog(DialogTypes.StudentZoomMeeting)}/>
                <StudentChatDialog open={dialogStore.getDialogState(DialogTypes.StudentChats)} onClose={() => closeDialog(DialogTypes.StudentChats)}/>
                <ResendLoginDialog open={dialogStore.getDialogState(DialogTypes.ResendLogin)} onClose={() => closeDialog(DialogTypes.ResendLogin)}/>
                {isDesktop() && <TeacherStartMeetingDialog open={dialogStore.getDialogState(DialogTypes.TeacherStartMeeting)}
                                                           onClose={() => closeDialog(DialogTypes.TeacherStartMeeting)}/>}

            </div>
        );
    }
}

export default AppDialogsContainer;
